
















import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/AdminNavbar.css';

const AdminNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [masterDropdownOpen, setMasterDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    sessionStorage.removeItem('isAdmin');
    navigate('/login');
  };

  const isActive = (path) => {
    // Check if the current path starts with the given path
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname === '/dashbord' ? 'active' : '';
    }
    return location.pathname.startsWith(path) ? 'active' : '';
  };
  
  // Toggle dropdown menu
  const toggleMasterDropdown = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setMasterDropdownOpen(!masterDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMasterDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-container">
        <div className="admin-logo">
          <Link to="/dashbord">ECL Shipping Admin</Link>
        </div>
        <ul className="admin-menu">
          <li>
            <Link to="/dashbord" className={isActive('/dashboard')}>
              Dashboard
            </Link>
          </li>
          
          {/* Master Dropdown */}
          <li className="dropdown" ref={dropdownRef}>
            <button 
              className={`dropdown-toggle ${masterDropdownOpen ? 'active' : ''}`} 
              onClick={toggleMasterDropdown}
            >
              Master
              {/* Master <span className="dropdown-arrow">▼</span> */}
            </button>
            
            <ul className={`dropdown-menu ${masterDropdownOpen ? 'show' : ''}`}>
              <li>
                <Link to="/admin/master-equipment/category">Category</Link>
              </li>
              <li>
                <Link to="/admin/master-equipment/attribute">Attribute</Link>
              </li>
            </ul>
          </li>
          
          <li>
            <Link to="/admin/equipment" className={isActive('/admin/equipment')}>
              Equipment
            </Link>
          </li>
          <li>
            <Link to="/admin/schedule" className={isActive('/admin/schedule')}>
              Sailing Schedule
            </Link>
          </li>
          <li>
            <Link to="/admin/profile" className={isActive('/admin/profile')}>
              Profile
            </Link>
          </li>
          <li>
            <Link to="/" className="nav-link">View Site</Link>
          </li>
          <li>
            <button onClick={handleLogout} className="logout-button">Logout</button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AdminNavbar;